module.exports = __webpack_public_path__ + "static/media/cloud-1.82e7c0b7.svg";